/**
 * Rules shared by the Add More File dialog and the documents grid.
 *
 * Each of these is ALSO enforced by the API (`pan.service.ts`
 * `uploadStaffFile` / `deleteStaffFile`) — the copies here only keep the user
 * from making a round trip to be told no. The API's answer is the real one.
 */

/** Matches STAFF_FILE_REMARK_MAX_LENGTH in sjbt-api `pan.service.ts`. */
export const STAFF_FILE_REMARK_MAX_LENGTH = 250;

/**
 * Staff may attach files at every status after verify — from FORM_FILL_PENDING
 * on through DONE. Before verify the document set is not yet reviewed.
 *
 * Matches STAFF_FILE_EDITABLE_STATUSES in sjbt-api `pan.service.ts`.
 */
export const STAFF_FILE_EDITABLE_STATUSES = [
  "FORM_FILL_PENDING",
  "FORM_FILL_IN_PROGRESS",
  "VERIFY",
  "GENERATE",
  "DONE",
];

export const canManageStaffFiles = (status?: string): boolean =>
  STAFF_FILE_EDITABLE_STATUSES.includes(status || "");

/** The upload folder, which is also what separates these at cleanup time. */
export const STAFF_FILE_UPLOAD_FOLDER = "PAN_STAFF_FILES";
